import React from 'react';
import { frontendModules } from './frontendUrls';

export default function FrontendDomains({ value }) {
  return <div className="portal-form-section">
    <h3>Domínios dos módulos</h3>
    <p className="form-text">Configure o endereço de acesso de cada módulo. Deixe em branco para usar o endereço padrão da OnTest. Informe apenas o domínio com https://, sem o caminho de login.</p>
    <div className="portal-admin-grid">
      {frontendModules.map(([module, label, fallback]) => <label className="form-label" key={module}>
        <span>{label}</span>
        <input className="form-control" name={`frontend_domains[${module}]`} type="url"
          maxLength={255} placeholder={fallback} defaultValue={value?.[module] || ''}
          title={`Domínio do módulo ${label}. Vazio: ${fallback}. O domínio deve estar configurado na hospedagem e ter certificado HTTPS.`} />
      </label>)}
    </div>
  </div>;
}
